<template>
  <footer class="footer">
    <div class="limit-grid">
      <div class="footer__logo">
        <img src="@/assets/logo-footer.svg" alt="Logo Sport" />
      </div>

      <div class="footer__contact">
        <div class="footer__social">
          <a
            href="https://www.facebook.com/cdtsport/"
            target="_blank"
            rel="noopener noreferrer"
            aria-label="Facebook"
          >
            <img src="@/assets/icons/facebook.png" alt="Facebook" />
          </a>
          <a
            href="https://www.instagram.com/cartaodetodossport/"
            target="_blank"
            rel="noopener noreferrer"
            aria-label="Instagram"
          >
            <img src="@/assets/icons/instagram.png" alt="Instagram" />
          </a>
          <a
            href="https://x.com/cdtsport/"
            target="_blank"
            rel="noopener noreferrer"
            aria-label="X"
          >
            <img src="@/assets/icons/x.png" alt="X" />
          </a>
        </div>

        <div class="footer__phones">
          <section class="footer__phone">
            <p>Central de vendas</p>
            <a href="tel:08007292076">0800 729 2076</a>
          </section>
          <section class="footer__phone">
            <p>SAC</p>
            <a href="tel:08002838916">0800 283 8916</a>
          </section>
        </div>

        <router-link :to="{ name: 'Contact' }" class="footer__cta">
          Fale conosco
        </router-link>
      </div>

      <div class="footer__disclaimer">
        <p>
          * Cartão de desconto não é plano de saúde, não garante e não se
          responsabiliza pelos serviços oferecidos e pelo pagamento das
          despesas, nem assegura desconto em todos os serviços obrigatoriamente
          garantidos por plano de saúde. Tudo o que o cliente usar ou comprar
          será por ele pago ao prestador, assegurando-se apenas os preços e
          descontos que constam na relação de empresas e serviços conveniados
          disponibilizada no site www.cartaodetodos.com.br. O atendimento será
          em até 15 dias, mediante disponibilidade na clínica. Consulte a
          clínica parceira para as especialidades disponíveis e condições para
          marcar as consultas.
        </p>
      </div>

      <div class="footer__brands">
        <a
          class="footer__contract"
          href="https://cartaodetodos.com.br/wp-content/uploads/2023/04/Contrato-de-AdCDT2023.pdf"
          target="_blank"
          rel="noopener noreferrer"
        >
          Contrato de adesão
        </a>

        <div class="footer__product">
          <p>Um produto</p>
          <a
            href="https://cartaodetodos.com.br/"
            target="_blank"
            rel="noopener noreferrer"
          >
            <img
              src="@/assets/icons/logo-cartao-de-todos.png"
              alt="Cartão de TODOS"
            />
          </a>
        </div>

        <a
          class="footer__gt7"
          href="https://www.gt7.com.br/"
          target="_blank"
          rel="noopener noreferrer"
        >
          <img src="@/assets/icons/gt7.png" alt="GT7" />
        </a>
      </div>
    </div>
    <!-- <TheChat /> -->
  </footer>
</template>

<script>
export default {};
</script>

<style lang="scss">
.footer {
  color: $color-white;
  background: $color-black;
  padding: 48px 0 40px;

  @include media(">=tablet") {
    padding: 64px 0 48px;
  }

  &__logo {
    text-align: center;

    img {
      height: 98px;
      width: auto;
    }
  }

  &__contact {
    display: grid;
    grid-template-columns: 1fr;
    grid-gap: 32px;
    justify-items: center;
    align-items: center;
    margin-top: 32px;

    @include media(">=tablet") {
      grid-template-columns: max-content 1fr max-content;
      grid-gap: 40px;
      margin-top: 40px;
    }
  }

  &__social {
    display: grid;
    grid-template-columns: repeat(3, max-content);
    grid-gap: 28px;
    align-items: center;

    a {
      display: flex;
      align-items: center;
      justify-content: center;
      transition: 0.3s ease-in-out;

      &:hover {
        opacity: 0.7;
      }

      img {
        height: 24px;
        width: auto;
      }
    }
  }

  &__phones {
    display: grid;
    grid-template-columns: 1fr;
    grid-gap: 24px;
    justify-items: center;
    width: 100%;

    @include media(">=tablet") {
      grid-template-columns: repeat(2, auto);
      grid-gap: 64px;
      justify-content: center;
    }
  }

  &__phone {
    text-align: center;

    p {
      font-family: "Lato", sans-serif;
      font-size: 20px;
      line-height: 24px;
      font-weight: 400;
      color: $color-lightgray;
    }

    a {
      display: block;
      font-family: "Open Sans", sans-serif;
      font-size: 34px;
      line-height: 42px;
      font-weight: 800;
      margin-top: 4px;
      color: $color-lightgray;
      text-decoration: none;
      transition: 0.3s ease-in-out;
      white-space: nowrap;

      &:hover {
        color: $color-primary;
      }
    }
  }

  &__cta {
    display: inline-flex;
    align-items: center;
    justify-content: center;
    min-width: 240px;
    padding: 16px 40px;
    border: 1px solid $color-lightgray;
    border-radius: 40px;
    font-family: "Lato", sans-serif;
    font-size: 18px;
    font-weight: 700;
    color: $color-lightgray;
    text-decoration: none;
    transition: 0.3s ease-in-out;

    &:hover {
      background: $color-lightgray;
      color: $color-black;
    }
  }

  &__disclaimer {
    margin-top: 40px;

    p {
      font-family: "Lato", sans-serif;
      font-size: 12px;
      line-height: 16px;
      font-weight: 400;
      text-align: center;
      color: $color-lightgray;
    }
  }

  &__brands {
    display: grid;
    grid-template-columns: 1fr;
    grid-gap: 24px;
    justify-items: center;
    align-items: center;
    margin-top: 32px;

    @include media(">=tablet") {
      grid-template-columns: repeat(3, max-content);
      grid-gap: 48px;
      justify-content: center;
    }
  }

  &__contract {
    font-family: "Lato", sans-serif;
    font-size: 14px;
    color: $color-lightgray;
    text-decoration: underline;
    transition: 0.3s ease-in-out;

    &:hover {
      color: $color-primary;
    }
  }

  &__product {
    display: flex;
    align-items: center;
    grid-gap: 12px;

    p {
      font-family: "Lato", sans-serif;
      font-size: 14px;
      font-weight: 700;
      color: $color-lightgray;
      white-space: nowrap;
    }

    a {
      display: flex;
      align-items: center;
      transition: 0.3s ease-in-out;

      &:hover {
        opacity: 0.7;
      }
    }

    img {
      height: 24px;
    }
  }

  &__gt7 {
    display: flex;
    align-items: center;
    transition: 0.3s ease-in-out;

    &:hover {
      opacity: 0.7;
    }

    img {
      height: 26px;
      width: auto;
    }
  }
}
</style>
